import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import moment from 'moment';

const LastSyncField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.lastMenuSyncDate
		? `${moment(latestSoftwareUpdateData.lastMenuSyncDate).format('MM/DD/YYYY h:mm:ss A')}`
		: undefined;

	return <FullInfoField label="lastMenuSyncLabel" value={inputValue} />;
};

export default LastSyncField;
